import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

export const localeInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const translocoService = inject(TranslocoService);
  const locale = translocoService.getActiveLang() ?? translocoService.getDefaultLang();
  if (locale) {
    req = req.clone({
      setHeaders: {
        'Accept-Language': locale,
      },
    });
  }
  return next(req);
};
